import { ComponentType } from 'react';

enum PlayerType {
  AUDIO = 'AUDIO',
  VIDEO = 'VIDEO',
  UNSUPPORTED = 'UNSUPPORTED',
}

interface IPlayerProps {
  url: string;
  mimeType: string;
  allowDownload?: boolean;
  controlsColor: string;
  onPlayRequested?(event: Event): void;
  onPlayAborted?(event: Event): void;
  onPlay?(event: Event): void;
  onError?(error: MediaError): void;
  onDownloadClick?(): void;
}

interface IPlayerWrapper {
  type: PlayerType;
  canPlay(mimeType: string): boolean;
  component: ComponentType<IPlayerProps>;
}

export { PlayerType, IPlayerProps, IPlayerWrapper };
